import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private drawerIsOpened = new BehaviorSubject<boolean>(null);

  constructor() {}

  get getDrawerIsOpened() {
    return this.drawerIsOpened.asObservable();
  }

  getDrawerAllowedRoutes() {
    return {
      home: 1,
      membro: true,
      area: true,
      setor: true,
      celula: true,
      patrimonio: true,
      frequencia: true,
      dashboard: true,
      palavra: true,
      'minha-conta': true,
      crianca: true,
    };
  }
}
